module.exports = __webpack_public_path__ + "img/6.b0fb045f.png";